import React from 'react';
import BaseLayer from './BaseLayer';
import { findDOMNode } from 'react-dom';
import { List, Map } from 'immutable';

class YandexLayer extends BaseLayer {
  constructor (props) {
    super(props);

    this.clustersInfrastructure = new Map();
  }

  getBounds () {
    const bounds = this.map.getBounds();

    return {
      southwest_lng: bounds[0][1], // юго запад - нижний левый
      southwest_lat: bounds[0][0],
      northeast_lng: bounds[1][1], // севего восток - верхний правый
      northeast_lat: bounds[1][0]
    };
  }

  renderSimilar (items) {
    if (!this.map) {
      return;
    }
    const features = items.map(item => {
      return {
        type: 'Feature',
        id: item.id,
        data: item,
        geometry: {
          type: 'Point',
          coordinates: [item.lat, item.lon]
        }
      };
    });

    const objectManager = new window.ymaps.ObjectManager({
      clusterize: true,
      preset: 'islands#darkOrangeClusterIcons',
      clusterIconColor: '#ff7f29',
      clusterDisableClickZoom: true,
      clusterOpenBalloonOnClick: false
    });

    objectManager.objects.options.set({
      preset: 'islands#darkOrangeCircleIcon',
      iconColor: '#ff7f29'
    });

    objectManager.add(features);

    objectManager.clusters.events.add('click', e => {
      const cluster = objectManager.clusters.getById(e.get('objectId'));
      const items = cluster.properties.geoObjects.map(function (item) {
        return item.data;
      });
      this.openBalloon(e.get('coords'), items);
    });

    objectManager.objects.events.add('click', (e) => {
      const objectId = e.get('objectId');
      const item = objectManager.objects.getById(objectId).data;
      this.openBalloon(e.get('coords'), [item]);
    });

    this.map.geoObjects.add(objectManager);
  }

  openBalloon (coords, items) {
    this.map.balloon.open(coords, {
      content: BaseLayer.getRealtyPopup(items)
    }, {
      closeButton: false
    });
  }

  componentDidMount () {
    window.ymaps.ready(() => {
      const node = findDOMNode(this);
      this.map = new window.ymaps.Map(node, {
        center: [this.lat, this.lon],
        zoom: this.zoom,
        controls: []
      }, {
        nativeFullscreen: true,
        suppressMapOpenBlock: true,
        yandexMapDisablePoiInteractivity: true
      });

      this.map.events.add('click', () => this.map.balloon.close());
      this.map.controls.add('zoomControl', {position: { top: 45, right: 6 }});
      this.map.controls.add('fullscreenControl', {position: { top: 10, right: 6 }});

      this.renderMainPlacemark();

      this.handlerOnLoad();

      if (!this.props.similar.isEmpty()) {
        this.renderSimilar(this.props.similar.toJS());
      }
      if (this.clustersInfrastructure.isEmpty()) {
        this.willReceiveInfrastructure(this.props.listInfrastructure);
        this.renderInfrastructure(this.props.selectInfrastructureId);
      }
    });
  }

  renderMainPlacemark () {
    const iconLayout = window.ymaps.templateLayoutFactory.createClass('<div class="maps-placemark maps-main-placemark" />');

    const placemark = new window.ymaps.Placemark([this.lat, this.lon], null, {
      iconLayout: iconLayout,
      zIndex: 700,
      iconShape: {type: 'Circle', coordinates: [10, 10], radius: 10}
    });

    this.map.geoObjects.add(placemark);
  }

  willReceiveInfrastructure (listInfrastructure) {
    this.clustersInfrastructure = listInfrastructure.map((data, id) => {
      const layerGroup = new window.ymaps.GeoObjectCollection({}, {
        preset: 'islands#redCircleIcon',
        strokeWidth: 4,
        geodesic: true
      });

      const iconLayout = window.ymaps.templateLayoutFactory.createClass('<div class="maps-placemark map-icon map-icon-ya map-icon-' + id + '" />');
      data.get('items').map(item => {
        const marker = new window.ymaps.Placemark([item.getIn(['point', 'lat']), item.getIn(['point', 'lon'])], {
          balloonContent: BaseLayer.getInfrastructurePopup(item)
        }, {
          balloonCloseButton: false,
          hideIconOnBalloonOpen: false,
          iconLayout: iconLayout,
          zIndex: 700,
          iconShape: {type: 'Circle', coordinates: [10, 10], radius: 10}
        });

        layerGroup.add(marker);
      });

      return layerGroup;
    });
  }

  renderInfrastructure (selectInfrastructureId) {
    let categories;

    if (selectInfrastructureId) {
      categories = new List(selectInfrastructureId.split(','));
    } else {
      categories = new List();
    }

    this.clustersInfrastructure.map((cluster, id) => {
      if (categories.includes(id)) {
        this.map.geoObjects.add(cluster);
      } else {
        this.map.geoObjects.remove(cluster);
      }
    });
  }

  componentWillUnmount () {
    this.map.destroy();
  }

  render () {
    return (
      <div className='yandex-content' />
    );
  }
}

export default YandexLayer;



// WEBPACK FOOTER //
// ./src/ui/Maps/Layers/YandexLayer.jsx